import { ContentPageListingResponse } from '@/types'
import { AgentConfiguration } from '@big-red-group/storefront-common-checkout'

type StyleObject = {
  [key: string]: string
}

export const convertToReactCSS = (stylesheet: string): React.CSSProperties => {
  const lines = stylesheet.split('\n')
  const styleObject: StyleObject = {}

  lines.forEach((line) => {
    const parts = line.split(/:\s*/)
    if (parts.length === 2) {
      const property = parts[0].trim()
      const value = parts[1].replace(/;/g, '').trim()
      styleObject[property] = value
    }
  })

  return styleObject
}

export async function getBlogLandingPageResponse(
  agentConfiguration: AgentConfiguration,
  entityId?: string | null
): Promise<ContentPageListingResponse> {
  const BLOG_ENTITY_TYPE = 'tag'
  const BLOG_QUANTITY = 36
  const query = new URLSearchParams({ ...agentConfiguration, quantity: BLOG_QUANTITY.toString() })

  if (entityId) {
    query.append('entityType', BLOG_ENTITY_TYPE.toString())
    query.append('entityId', entityId)
  }

  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_LOKI_AJAX_BASE_URL}/storefront-resources/blog-listing?${query}`,
      {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
        },
      }
    )
    if (!res.ok) {
      return { error: true }
    }
    return await res.json()
  } catch (error) {
    return { error: true }
  }
}
